import { render, staticRenderFns } from "./VideoArchive.vue?vue&type=template&id=3c67d5e4"
import script from "./VideoArchive.vue?vue&type=script&lang=js"
export * from "./VideoArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports